import React from 'react'
import { Meta, MetaTitle, MetaView } from './styles'
import { Text } from 'styles/reactnative'
import { Input, Popover, Select, Space } from 'antd'
import { use } from 'i18next'
import { useUserGroup } from '../../hooks/user/usergroups'

const UserCreateInput = ({ value, setValue, name, placeholder }) => {
	const { type2 } = useUserGroup()
	return (
		<MetaView>
			<MetaTitle>
				<Text>{name}</Text>
			</MetaTitle>
			<Meta
				style={{
					background: 'transparent',
					padding: 0,
				}}>
				{name == '그룹추천코드' ? (
					<Popover
						trigger={'click'}
						color="#cdcdcd"
						content={
							<Space style={{ alignItems: 'center' }}>
								그룹조회
								<Select
									defaultValue={''}
									onChange={e => {
										//{ value: '', label: '전체' },

										setValue(e)
									}}
									value={value}
									style={{ width: '100%', minWidth: 200 }}
									options={[
										{ value: '', label: '전체' },
										...(type2 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder={placeholder}
							value={value}
							onChange={e => setValue(e.target.value)}
						/>
					</Popover>
				) : (
					<Input
						placeholder={placeholder}
						value={value}
						onChange={e => setValue(e.target.value)}
					/>
				)}
			</Meta>
		</MetaView>
	)
}

export default UserCreateInput
